import { forwardRef } from 'react';

interface LeaderboardEntry {
  id: string;
  user_id: string | null;
  display_name: string | null;
  total_points: number | null;
  correct_winners: number | null;
  correct_scores: number | null;
  rank: number | null;
}

interface LeaderboardCaptureProps {
  entries: LeaderboardEntry[];
  groupName: string;
}

const LeaderboardCapture = forwardRef<HTMLDivElement, LeaderboardCaptureProps>(
  ({ entries, groupName }, ref) => {
    const top10 = entries.slice(0, 10);

    return (
      <div
        ref={ref}
        style={{
          position: 'fixed',
          left: '-9999px',
          top: 0,
          width: '600px',
          pointerEvents: 'none',
          fontFamily: 'Leon, AOTSerialMono, Inter, system-ui, sans-serif',
          direction: 'rtl',
          background: 'hsl(0, 0%, 5%)',
          color: '#fff',
          padding: '32px',
          borderRadius: '16px',
        }}
      >
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h2
            style={{
              fontSize: '24px',
              fontWeight: 700,
              letterSpacing: '-0.025em',
              margin: 0,
            }}
          >
            {groupName}
          </h2>
          <p
            style={{
              fontSize: '14px',
              color: 'rgba(255,255,255,0.65)',
              marginTop: '4px',
              textTransform: 'uppercase',
              letterSpacing: '0.2em',
            }}
          >
            טבלת דירוג
          </p>
        </div>

        {/* Entries */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {top10.map((entry, i) => {
            const rank = entry.rank || i + 1;
            const isTop3 = rank <= 3;
            const rankColor = isTop3 ? 'hsl(24, 95%, 53%)' : 'rgba(255,255,255,0.5)';

            return (
              <div
                key={entry.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '12px 16px',
                  background: isTop3 ? 'hsl(0, 0%, 10%)' : 'hsl(0, 0%, 8%)',
                  borderRadius: '12px',
                  border: isTop3 ? '1px solid hsl(24, 95%, 53%, 0.3)' : '1px solid transparent',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span
                    style={{
                      fontSize: '20px',
                      fontWeight: 700,
                      color: rankColor,
                      width: '32px',
                      textAlign: 'center',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {rank}
                  </span>
                  <span style={{ fontSize: '16px', fontWeight: 600 }}>
                    {entry.display_name}
                  </span>
                </div>
                <span
                  style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: 'hsl(24, 95%, 53%)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {entry.total_points || 0}
                </span>
              </div>
            );
          })}
        </div>

        {/* Watermark */}
        <div
          style={{
            textAlign: 'center',
            marginTop: '24px',
            paddingTop: '16px',
            borderTop: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', margin: 0 }}>
            <span style={{ fontWeight: 700 }}>BRACKET</span>{' '}<span style={{ color: 'hsl(24, 95%, 53%)', fontWeight: 700 }}>RUN</span>
            {' — '}
            משחק ניחושי פלייאוף NBA
          </p>
        </div>
      </div>
    );
  }
);

LeaderboardCapture.displayName = 'LeaderboardCapture';

export default LeaderboardCapture;
